import 'bootstrap/js/dist/dropdown.js';
import $ from 'jquery';
import A11yUtils from '@core/base/scripts/utils/a11y-utils.js';

export default class DropdownWithCta {
  constructor(container){
    this.container=container;
    this.DATA_TOGGGLE='data-toggle';
    this.$menuFocusables;
    this.$dropDowns;
    this.$currentLink;
    this.isOpen=false;
  }

  init(){
    this.$dropDowns= $('.dropdown,.dropup',this.container);
    //
    this.$dropDowns.on('shown.bs.dropdown', e=> {
      this.open(e);
    });
    this.$dropDowns.on('hidden.bs.dropdown', e=> {
      this.close(e);
    });

    this.$dropDowns.find(`[${this.DATA_TOGGGLE}]`).dropdown();
  }

  open(e){
    this.isOpen=true;
    const $that=$(e.currentTarget);
    this.$currentLink=$that.find(`[${this.DATA_TOGGGLE}]`);
    this.$menuFocusables =  $that.find('.dropdown-menu').find(A11yUtils.FOCUSABLES_VISIBLE);
    if(this.$menuFocusables.length>0){
      this.$menuFocusables[0].focus();
    }
    this.keydownEvents();
    $(window).trigger('dropdown:open');
  }

  close(e){
    this.isOpen=false;
    this.$menuFocusables.off();
    $(window).trigger('dropdown:close');
  }

  keydownEvents() {
    this.$menuFocusables.on('keydown', (evt) => {
      const key = evt.which;
      if (key === A11yUtils.keyboard.esc) {
        evt.preventDefault();
        this.close();
        this.$currentLink.focus();
        return;
      }
    });
  }


  destroy(){
    this.$dropDowns.dropdown('dispose')
  }
}


